<template>
  <div class="language" @mouseleave="openDialog = false">
    <div class="current" v-if="selectedLanguage">
      <div @click="openDialog = true" @mouseover="openDialog = true">
        <div
          class="flag"
          :style="[{ backgroundImage: `url(${selectedLanguage.flag_img_path})` }]"
        ></div>
      </div>
    </div>
    <div class="list" :class="{ open: openDialog }" :style="listStyle">
      <div class="">
        <ul>
          <li
            class="item"
            v-for="language in languages"
            :key="language.id"
            @click="changeLocale(language)"
          >
            <img :src="language.flag_img_path" class="flag" />
            <span>
              {{ language.name }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Spinner from "../Spinner";
import EventBus from "../../eventbus";
import languages from "../../lang/languages";

export default {
  components: {
    Spinner,
  },
  props: {
    displayToRight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      languages: languages,
      selectedLanguage: null,
      openDialog: false,
    };
  },
  mounted() {
    const selectedLanguageCode = this.$i18n.locale;
    this.selectedLanguage =
      this.languages.find((lang) => lang.code === selectedLanguageCode) || null;

    EventBus.$on("languageChanged", this.languageChangedHandler);
  },
  methods: {
    changeLocale(language) {
      this.openDialog = false;
      EventBus.changeLanguage(language);
    },
    languageChangedHandler(language) {
      this.selectedLanguage = language;
    },
  },
  computed: {
    listStyle() {
      return {
        left: this.displayToRight ? 0 : "auto",
        right: this.displayToRight ? "auto" : 0,
      };
    },
  },
  beforeDestroy() {
    EventBus.$off("languageChanged", this.languageChangedHandler);
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";

.flag {
  $SIZE: 2.5em;
  $MOBILE_SIZE: 30px;
  border-radius: 100%;

  cursor: pointer;
  height: $SIZE;
  width: $SIZE;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  @media (max-width: 768px) {
    height: $MOBILE_SIZE;
    width: $MOBILE_SIZE;
  }
}

.language {
  position: relative;

  .list {
    display: none;
    position: absolute;
    top: 36px;
    // width: 200px;
    height: auto;
    background-color: rgba(0, 0, 0, 0.75);
    color: #ffffff;
    z-index: 20;

    &.open {
      display: block;
    }

    ul {
      list-style: none;
      padding: 0 0;
      margin: 0 0;

      .item {
        display: flex;
        align-content: center;
        text-align: left;
        padding: 10px 10px;
        line-height: 36px;
        cursor: pointer;
        transition: color 500ms ease, background-color 500ms ease;

        &:hover {
          background-color: var(--pallete_clear_color);
          color: var(--pallete_dark_text_color);
        }

        img {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
